
import { ToastFactory } from '@/utils/ToastFactory';
import { FilterMatchMode } from 'primevue/api';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { LicenseService } from './license.service';
const licenseService = new LicenseService();

export default defineComponent({
    name: 'ListLicenses',
    data() {
        return {
            licensesTotal: 0,
            licenses: [],
            params:{ name: "", page: 0, size: 6, total: 0 },
            filters: null as any
        };
    },

    created(){
        this.initFilters();
    },

    computed: {
        ...mapGetters({
            storeLicenses: 'licenses/getLicenses'
        })
    },

    methods: {
        paginate(event: {page: number, rows: number}): void {
            this.getLicenses(this.params.name, event.page, event.rows)
        },

        getLicenses(name: string, page: number, size: number){
            licenseService.getLicenses({name, page, size}).then(() => {
                this.licenses = this.storeLicenses.content;
                this.params.total = this.storeLicenses.total;
            });
        },

        getAlLicensesDatabase(page: number, size: number){
            licenseService.getLicenses({page, size}).then(() => {
                this.licensesTotal = this.storeLicenses.total;    
            });
        },

        licensesPaginate(): void {
            const page = this.params.page;
            const size = this.params.size;
            const name = this.params.name;
            this.getLicenses(name, page, size);
        },

        deleteLicense(id: any): void {
            licenseService.deleteLicense(id).then(() => {
                this.licensesPaginate();
                this.getAlLicensesDatabase(this.params.page, this.params.size)
                this.$toast.add(ToastFactory.success(this.$t("toast.sucessLicenseDelete")));
            }).catch(() => {
                this.$toast.add(ToastFactory.error(this.$t("toast.errorLicenseDelete")));
            })
        },

        confirmDelete(id: any){
            this.$confirm.require({
                header: this.$t('license.delete'),
                message: this.$t('license.confirmDelete'),
                accept: () => {
                    this.deleteLicense(id);
                },
                reject: () => {
                    console.log('reject');
                }
            });
        },

        initFilters(){
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            }
        }
    },

    mounted() {
        this.licensesPaginate();
        this.getAlLicensesDatabase(this.params.page, this.params.size)
    }
});
